export const NA = 'N/A';
export const UNKNOWN_ACTIVITY_TYPE = 'Unknown activity type';
export const UNKNOWN_REASON = 'Unknown reason';
export const typeLabels = {
	driving: 'Work assignment',
	hosting: 'Work assignment',
	deadhead: 'Deadhead',
	traveling: 'Traveling',
	protection: 'Protection',
};

export const overlappingErrorMessages = {
	crewMemberAlreadyAssigned: 'This crew member is already assigned.',
	tooManyAssignmentsForActivityType: 'Too many assignments for this activity type.',
	workAssignmentAlreadyUpdated: 'This work assignment has already been updated.',
	statusCantBeUpdated: 'The status of this work assignment cannot be updated.',
	actualStatusAssignedBeforeAssignmentCompletion:
		'The actual status was assigned before the assignment was completed.',
	invalidActivityType: 'Invalid activity type.',
};
